import script from "./GroupControl.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupControl.vue?vue&type=script&setup=true&lang=js"

import "./GroupControl.vue?vue&type=style&index=0&id=24838094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24838094"]])

export default __exports__